import { LANG_JAPANESE_TITLE } from '@/common/constants';

const state = {
  emailCheck: false,
  baseUrl: '',
  eventSuccess: false,
  unauthorized: false,
  checkAuth: {
    isAuthenticated: false,
    isUnauthorized: null
  },
  checkAuthReceptionist: {
    isAuthenticated: false,
    isUnauthorized: null
  },
  fullPath: null,
  meReceptionist: null,
  checkInData: null,
  listCheckInReception: null,
  checkEvent: {
    event_id: null,
    contract_id: null,
    success: null,
    fullPath: null
  },
  constants: {},
  eventMaster: null,
  registrationPeriodStatus: null,
  lang: 'jp_en',
  registerData: {
    stepOne: {},
    stepTwo: {}
  },
  registerStatus: null,
  registerResult: null,
  registerResultStatus: null,
  isAuthenticate: null,
  company: {
    listCompany: null
  },
  companyDetail: null,
  previewCompanyStatus: false,
  profile: null,
  updateBasicInformationStatus: false,
  updateEntryInformationStatus: false,
  applicantCompanyInterview: null,
  applicantInterviewStatus: null,
  eventInterviewNote: null,
  landingPageLinkData: {},
  dataEventSchedule: null,
  dataLanguage: [
    {
      lang_code: 'jp_en',
      lang_name: LANG_JAPANESE_TITLE
    }
  ],
  defaultLanguage: 1,
  langTitle: '',
  contract_id: '',
  event_code: ''
};
export default state;
